import React from 'react';
import { withStyles } from '@material-ui/styles';
import { Checkbox, Modal, TextField, Typography } from '@material-ui/core';
import ReactTable from 'react-table';
import ActionButton from '../../../components/ActionButton';
import PropTypes from 'prop-types';

const styles = (theme) => ({
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    gap: '20px',
    textAlign: 'center',
    backgroundColor: 'white',
    color: 'black',
    padding: '20px',
    boxShadow: theme.shadows[6],
    borderRadius: '6px',
    overflowY: 'auto',
    width: '70%',
    maxWidth: '750px',
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  modalSectionContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
    width: '85%',
  },
  selectAllWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
  },
});

class ModalSelezioneAssociazioneScheda extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      records: [],
      columns: [],
      areAllRepartiChecked: true,
    };
  }

  componentDidMount = () => {
    let repartiRecords = [];
    if (this.props.reparti.length === 1) {
      repartiRecords.push({
        nomeReparto: this.props.reparti[0].nome,
        checked: true,
        idReparto: this.props.reparti[0].id,
        repartoDefault: true,
      });
    } else {
      this.props.reparti.forEach((item) => {
        if (!item.repartoDefault) {
          repartiRecords.push({
            nomeReparto: item.nome,
            checked: !!this.props.schedaData[0]?.reparti.includes(item.id),
            idReparto: item.id,
            repartoDefault: false,
          });
        }
      });
    }
    const columns = this.getColumnTabellaReparti();
    this.setState(
      {
        records: repartiRecords,
        isButtonsAllChecked: true,
        columns: columns,
      },
      () => {
        this.checkIfAllAreSelected();
      },
    );
  };

  getColumnTabellaReparti = () => {
    return [
      {
        Header: 'Reparto',
        id: 'Reparto',
        minWidth: 250,
        accessor: (d) => d,
        Cell: (props) => (
          <TextField
            contentEditable={false}
            style={{ margin: 10 }}
            InputProps={{ disableUnderline: true }}
            inputProps={{ min: 0, style: { textAlign: 'center' } }}
            value={props.row.Reparto.nomeReparto}
          />
        ),
      },
      {
        Header: 'Associa',
        id: 'Associa',
        width: 180,
        accessor: (d) => d,
        Cell: (props) => (
          <Checkbox
            onClick={() => {
              let array = [...this.state.records];
              array[props.index].checked = !array[props.index].checked;
              this.setState(
                {
                  records: array,
                  areAllRepartiChecked: true,
                },
                () => {
                  this.checkIfAllAreSelected();
                },
              );
            }}
            checked={props.row.Reparto.checked}
            disabled={props.row.Associa.repartoDefault}
            style={{ margin: 10 }}
          />
        ),
      },
    ];
  };

  selectAll = () => {
    this.setState((prevState) => {
      let allSelected = prevState.areAllRepartiChecked;

      let updatedRecords = prevState.records.map((item) => ({
        ...item,
        checked: item.repartoDefault ? true : !allSelected, // Mantieni i reparti default sempre selezionati
      }));

      return {
        records: updatedRecords,
        areAllRepartiChecked: !allSelected,
      };
    });
  };

  checkIfAllAreSelected = () => {
    this.setState((prevState) => {
      const allChecked = prevState.records.every((item) => item.checked);
      return { areAllRepartiChecked: allChecked };
    });
  };

  render() {
    const { classes } = this.props;

    return (
      <Modal
        open={this.props.open}
        onClose={this.props.onClose}
        className={classes.modal}
      >
        <div className={classes.modalContainer}>
          <div className={classes.modalSectionContainer}>
            <Typography style={{ align: 'center', fontSize: 30 }}>
              Reparti
            </Typography>
            <div className={classes.selectAllWrapper}>
              <ActionButton
                size="small"
                disabled={false}
                grayVersion={false}
                label={
                  this.state.areAllRepartiChecked
                    ? 'Deseleziona tutto'
                    : 'Seleziona tutto'
                }
                onClick={this.selectAll}
              />
            </div>
            <ReactTable
              filterable={false}
              resizable={true}
              enableEditing={true}
              showPageSizeOptions={false}
              showPageJump={true}
              defaultPageSize={5}
              data={this.state.records}
              columns={this.state.columns}
              previousText="Precedente"
              nextText="Successivo"
              noDataText="Nessun record"
              pageText="Pagina"
              ofText="di"
              rowsText="righe"
              pageJumpText="Vai a pagina"
              rowsSelectorText="righe per pagina"
            />
          </div>
          <div>
            <ActionButton
              label="Chiudi"
              secondaryButton
              onClick={this.props.onClose}
            />
            <ActionButton
              disabled={false}
              grayVersion={false}
              label="Salva"
              onClick={() => this.props.saveValues(this.state.records)}
            />
          </div>
        </div>
      </Modal>
    );
  }
}

ModalSelezioneAssociazioneScheda.propTypes = {
  classes: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  reparti: PropTypes.array.isRequired,
  saveValues: PropTypes.func.isRequired,
  schedaData: PropTypes.array.isRequired,
};

export default withStyles(styles)(ModalSelezioneAssociazioneScheda);
